import Cookies from 'js-cookie';
import { addPopupToQueue } from './navbar.js';

export function initEmailPopup() {
    var $emailPopup = $('#emailPopup');

    var options = {
        backdrop: 'static',
        keyboard: false,
    };

    if ($emailPopup.length) {
        addPopupToQueue($emailPopup, options);
    }
}

export function initOrderMethodPopup() {
    var paceOrderMethodCookie = Cookies.get('pace-ordering-mode');

    if (paceOrderMethodCookie !== undefined) {
        return false;
    }

    var $orderingModeModal = $('#orderingModeModal');

    if ($orderingModeModal.length) {
        addPopupToQueue($orderingModeModal);

        Cookies.set('pace-ordering-mode', '1', { expires: 365 * 10, path: "/;SameSite=None", secure: true });
    }
}

export function initUserMessagePopup() {
    var $userMessageModal = $('#userMessageModal');

    if ($userMessageModal.length) {
        addPopupToQueue($userMessageModal);

        $userMessageModal.on('hidden.bs.modal', function () {
            $.get('account/ajaxClearUserMessage', function () {
                $userMessageModal.remove();
            });
        });
    }
}
